import Form from "@modules/forms/Form.js";

const ContactFlats = {
    init() {
        this.el = $('[form="ContactFlats"]');
        if (!this.el.length) return;

        this.popupButtons = $('[popup="contactFlats"]');
        this.select = this.el.find('#type');
        this.groups = this.el.find('.group');

        this.start();
        this.bind();
    },

    start() {
        this.groups.hide(0);
    },

    bind() {
        this.popupButtons.click((evt) => {
            const val = $(evt.currentTarget).data();
            this.select.val(val.type).trigger("change");
            return false;
        });

        this.select.change((evt) => {
            const val = $(evt.currentTarget).val();
            this.show(val);
        });
    },

    show(group) {
        this.groups.find("select").prop("disabled", true);
        this.groups.find(".required").removeClass("required");
        this.groups.hide(0);

        if (!group || !$("." + group).length) {
            return;
        }

        this.el.find("." + group).find(".input").addClass("required");
        this.el.find("." + group).find("select").prop("disabled", false);
        this.el.find("." + group).show(0);

        Form.bind(this.el);
    }
}

export default ContactFlats;